import React from "react";
import Footer from "../../componets/Footer/Footer";
import Navbar from "../../componets/Navbar/Navbar";
import CookiesPolicySection from "./CookiesPolicySection";

const CookiesPolicy = () => {
  const classSend = "position-relative";

  return (
    <>
      <Navbar classSend={classSend} />
      <CookiesPolicySection />
      <Footer />
    </>
  );
};

export default CookiesPolicy;
